function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing8, spacing32 } from "@churchofjesuschrist/eden-style-constants";
import AspectRatio from "@churchofjesuschrist/eden-aspect-ratio";
/* margin-block-start is used to account for card padding */

const UnconstrainedStub = styled.div.withConfig({
  componentId: "sc-123tyw6-0"
})(["margin-block-start:calc(", " - ", ");padding-inline-start:", ";position:relative;"], spacing32, spacing8, spacing8); // wraps icon or bar

const StubFigure = _ref => {
  let {
    aspectRatio,
    children,
    ...props
  } = _ref;
  return aspectRatio ? /*#__PURE__*/React.createElement(AspectRatio, _extends({
    ratio: aspectRatio
  }, props), children) : /*#__PURE__*/React.createElement(UnconstrainedStub, props, children);
};

StubFigure.propTypes = {
  /** Contents of Stub */
  children: PropTypes.node.isRequired,

  /** Aspect ratio in which you want the figure displayed, in the form of n:n (e.g. "1:1", which is square) */
  aspectRatio: PropTypes.oneOf(["1:1", "5:6", "5:8", "6:5", "8:3", "8:5", "16:9"])
};
export default StubFigure;